import { useSWR } from '@tiger/swr';
import API from 'utils/API';
import { formatLetter } from './helper';
import { FormatLetterItemType, ProvinceType } from './type';

// 省市区数据默认使用英文
export const useGetProvinceData = (lang: string = 'en_US') =>
    useSWR<{
        data: ProvinceType[];
        formatData: FormatLetterItemType[];
    }>(
        {
            url: API.CUSTOMER.fields.cnArea(),
            params: {
                lang
            }
        },
        {
            immutable: true,
            dataChain: res => ({
                data: res.data,
                formatData: formatLetter(res.data)
            })
        }
    );
